import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './datePickerShimmerComponent.css';

const DatePickerShimmerComponent = () => {
  return (
    <div className="et-v2-date-picker-shimmer-container">
      {Array.from({length: 35}).map((_, index) => (
        <div key={index} className="et-v2-dpsc-date">
          <ShimmerComponent />
        </div>
      ))}
    </div>
  );
};

export default DatePickerShimmerComponent;
